var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50033 1.41699C4.5967 1.41699 1.41699 4.5967 1.41699 8.50033C1.41699 12.404 4.5967 15.5837 8.50033 15.5837C12.404 15.5837 15.5837 12.404 15.5837 8.50033C15.5837 4.5967 12.404 1.41699 8.50033 1.41699ZM8.50033 2.83366C11.6383 2.83366 14.167 5.36232 14.167 8.50033C14.167 11.6383 11.6383 14.167 8.50033 14.167C5.36232 14.167 2.83366 11.6383 2.83366 8.50033C2.83366 5.36232 5.36232 2.83366 8.50033 2.83366ZM7.79199 4.95866V6.37533H9.20866V4.95866H7.79199ZM7.79199 7.79199V12.042H9.20866V7.79199H7.79199Z",
    fill: "#878E95"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGray);
export default __webpack_public_path__ + "static/media/info-gray.02c17ec98bd0e3402e86e48b508295fd.svg";
export { ForwardRef as ReactComponent };